// extracted by mini-css-extract-plugin
export default {"tooltip":"ST-z","arrow":"TT-z"};